Bingo.UserEditFormVerifications = {};

Bingo.UserEditFormVerifications.init = () => {
    Bingo.UserEditFormVerifications.usernameInput = $('.js-userEditForm__usernameInput');
    Bingo.UserEditFormVerifications.usernameVerificationDiv = $('.js-userEditForm__usernameVerification');
    Bingo.UserEditFormVerifications.usernameVerifiedIcon = $('.js-userEditForm__usernameVerifiedIcon');
    Bingo.UserEditFormVerifications.usernameUnverifiedIcon = $('.js-userEditForm__usernameUnverifiedIcon');
    Bingo.UserEditFormVerifications.usernameUnverifiedTooltip = $('.js-userEditForm__usernameUnverifiedTooltip');
    Bingo.UserEditFormVerifications.usernameDefaultValue = Bingo.UserEditFormVerifications.usernameInput.val();
    Bingo.UserEditFormVerifications.usernameDefaultState = Bingo.UserEditFormVerifications.usernameVerificationDiv.data('default-verified');


    Bingo.UserEditFormVerifications.phoneInput = $('.js-userEditForm__phoneInput');
    Bingo.UserEditFormVerifications.phoneVerificationDiv = $('.js-userEditForm__phoneVerification');
    Bingo.UserEditFormVerifications.phoneVerifiedIcon = $('.js-userEditForm__phoneVerifiedIcon');
    Bingo.UserEditFormVerifications.phoneUnverifiedIcon = $('.js-userEditForm__phoneUnverifiedIcon');
    Bingo.UserEditFormVerifications.phoneUnverifiedTooltip = $('.js-userEditForm__phoneUnverifiedTooltip');
    Bingo.UserEditFormVerifications.phoneDefaultValue = Bingo.UserEditFormVerifications.phoneInput.val();
    Bingo.UserEditFormVerifications.phoneDefaultState = Bingo.UserEditFormVerifications.phoneVerificationDiv.data('default-verified');

    Bingo.UserEditFormVerifications.verifyUsername();
    Bingo.UserEditFormVerifications.usernameInput.on('input', () => {
        Bingo.UserEditFormVerifications.verifyUsername();
    });

    Bingo.UserEditFormVerifications.verifyPhone();
    Bingo.UserEditFormVerifications.phoneInput.on('input', () => {
        Bingo.UserEditFormVerifications.verifyPhone();
    });
};

Bingo.UserEditFormVerifications.verifyUsername = () => {
    const currentValue = Bingo.UserEditFormVerifications.usernameInput.val();
    if (Bingo.UserEditFormVerifications.usernameDefaultValue !== currentValue) {
        Bingo.UserEditFormVerifications.usernameUnverifiedTooltip.show();
    } else {
        Bingo.UserEditFormVerifications.usernameUnverifiedTooltip.hide();
    }

    if (Bingo.UserEditFormVerifications.usernameDefaultValue !== currentValue
        || (Bingo.UserEditFormVerifications.usernameDefaultValue === currentValue && Bingo.UserEditFormVerifications.usernameDefaultState === false)) {
        Bingo.UserEditFormVerifications.usernameVerifiedIcon.hide();
        Bingo.UserEditFormVerifications.usernameUnverifiedIcon.show();
    } else {
        Bingo.UserEditFormVerifications.usernameVerifiedIcon.show();
        Bingo.UserEditFormVerifications.usernameUnverifiedIcon.hide();
    }
};

Bingo.UserEditFormVerifications.verifyPhone = () => {
    const currentValue = Bingo.UserEditFormVerifications.phoneInput.val();
    if (currentValue !== '' && Bingo.UserEditFormVerifications.phoneDefaultValue !== currentValue) {
        Bingo.UserEditFormVerifications.phoneUnverifiedTooltip.show();
    } else {
        Bingo.UserEditFormVerifications.phoneUnverifiedTooltip.hide();
    }

    if (currentValue !== '') {
        if (Bingo.UserEditFormVerifications.phoneDefaultValue !== currentValue
            || (Bingo.UserEditFormVerifications.phoneDefaultValue === currentValue && Bingo.UserEditFormVerifications.phoneDefaultState === false)) {
            Bingo.UserEditFormVerifications.phoneVerifiedIcon.hide();
            Bingo.UserEditFormVerifications.phoneUnverifiedIcon.show();
        } else {
            Bingo.UserEditFormVerifications.phoneVerifiedIcon.show();
            Bingo.UserEditFormVerifications.phoneUnverifiedIcon.hide();
        }
    } else {
        Bingo.UserEditFormVerifications.phoneVerifiedIcon.hide();
        Bingo.UserEditFormVerifications.phoneUnverifiedIcon.hide();
    }
};
